export default __webpack_public_path__ + "static/background-540e2612170fa0df74915e70c705ba5e.jpg";